<template>
  <div class="onboardFormContainer">
    <div ref="map"></div>
    <div class="onboardFormHeader">
      <div class="onboardFormLogo"><img src="../../public/img/TurkishRestaurantLogo.png"/></div>
      <div class="onboardFormLegalNotice">
        We collect this information to better serve your business and help meet the requirements of regulators,
        financial partners, and our services.
      </div>
    </div>
    <div class="onboardForm">
      <form method="post">
        <label for="type-of-business">Type of Business:</label>
        <select id="type-of-business" name="type-of-business" required v-model="onboardingForm.type_of_business">
          <option v-for="(option, key) in typeOfBusinessOptions" :value="option.value" :key="key">
            {{ option.text }}
          </option>
        </select>

        <label for="business-structure">Business Structure:</label>
        <select id="business-structure" name="business-structure" required v-model="onboardingForm.business_structure">
          <option v-for="(option, key) in businessStructureOptions" :value="option.value" :key="key">
            {{ option.text }}
          </option>
        </select>

        <label for="legal-business-name">Legal Business Name:</label>
        <input id="legal-business-name" name="legal-business-name" type="text" required v-model="onboardingForm.legal_business_name">

        <label for="employer-identification-number">Employer Identification Number (EIN):</label>
        <input id="employer-identification-number" name="employer-identification-number" type="text" required v-model="onboardingForm.identification_number">

        <label for="doing-business-as">Doing Business As:</label>
        <input id="doing-business-as" name="doing-business-as" type="text" v-model="onboardingForm.doing_business_as">

        <label for="business-website">Business Website:</label>
        <input id="business-website" name="business-website" type="url" v-model="onboardingForm.business_website">

        <label for="legal-name">Legal Name:</label>
        <input id="legal-name" name="legal-name" type="text" required v-model="onboardingForm.legal_name">

        <label for="legal-last-name">Legal Last Name:</label>
        <input id="legal-last-name" name="legal-last-name" type="text" required v-model="onboardingForm.legal_last_name">

        <label for="email-address">Email Address:</label>
        <input id="email-address" name="email-address" type="email" required v-model="onboardingForm.email_address">

        <label for="date-of-birth">Date of Birth:</label>
        <input id="date-of-birth" name="date-of-birth" type="date" required v-model="onboardingForm.birthday">

        <fieldset>
          <legend>Home Address:</legend>
          <label>Business Address</label>
          <places :location="business_address" :placeholder="business_address" :found="placesFound" class="w-full"></places>

          <label for="street-address">Street Address:</label>
          <input id="street-address" name="street-address" type="text" required v-model="onboardingForm.street_address">

          <label for="city">City:</label>
          <input id="city" name="city" type="text" required v-model="onboardingForm.city">

          <label for="state">State:</label>
          <input id="state" name="state" type="text" required v-model="onboardingForm.state">

          <label for="zip-code">Zip Code:</label>
          <input id="zip-code" name="zip-code" type="text" required v-model="onboardingForm.zip_code">
        </fieldset>

        <div>
          <label for="phone-number">Phone Number:</label>
          <phone-mask-input
              v-model="onboardingForm.phone"
              autoDetectCountry
              showFlag
              @onValidate="onValidate"
              wrapperClass="relative"
              inputClass=""
              flagClass="phone-flag"
              v-validate="'required'"
              name="phone-number"
              id="phone-number"
              required
          />
        </div>
        <label for="last-4-ssn">Last 4 Digits of Social Security Number:</label>
        <input id="last-4-ssn" name="last-4-ssn" type="text" required v-model="onboardingForm.social_security_number">

        <label for="bank-routing-number">Bank Routing Number:</label>
        <input id="bank-routing-number" name="bank-routing-number" type="text" required v-model="onboardingForm.bank_routing_number">

        <label for="bank-account-number">Bank Account Number:</label>
        <input id="bank-account-number" name="bank-account-number" type="text" required v-model="onboardingForm.bank_account_number">

        <label class="checkbox-container">
        Turkish Restaurant LLC is never responsible for any taxes. I will not hold Turkish Restaurant LLC responsible for sales tax and all other applicable taxes that may arise. I agree to pay the sales tax and all other applicable taxes, which will consist of sales of all my accounts through the turkishrestaurant.com site, as required by law. I agree to pay a commission to Turkish Restaurant LLC at the rate I choose after every sale made through the turkishrestaurant.com site.
        <input type="checkbox" required name="check1" v-validate="'required'">
        <span class="checkmark"></span>
        </label>
        <label class="checkbox-container">
          By checking this box, I  agree to a monthly subscription fee of $150 for the first 6 months, followed by the option to cancel the subscription thereafter and accept a 3% transaction fee for each sale made through turkishrestaurant.com.
          <input type="checkbox" required name="check2" v-validate="'required'">
        <span class="checkmark"></span>
        </label>

        <button type="button" @click="saveOnboardingForm">Submit</button>
      </form>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import Places from '../components/google-places/Places'
import PhoneMaskInput from 'vue-phone-mask-input'

export default {
  components: {
    Places,
    PhoneMaskInput
  },
  data () {
    return {
      placeService: null,
      business_address: '',
      onboardingForm: {
        type_of_business: null,
        business_structure: null,
        legal_business_name: null,
        identification_number: null,
        doing_business_as: null,
        business_website: null,
        legal_last_name: null,
        legal_name: null,
        email_address: null,
        birthday: null,
        street_address: null,
        state: null,
        city: null,
        zip_code: null,
        phone: null,
        social_security_number: null,
        bank_routing_number: null,
        bank_account_number: null
      },
      typeOfBusinessOptions: [
        {
          text: 'Select',
          value: null
        },
        {
          text: 'Individual',
          value: 'individual'
        },
        {
          text: 'Company',
          value: 'company'
        },
        {
          text: 'Nonprofit Organization',
          value: 'nonprofit-organization'
        }
      ],
      businessStructureOptions: [
        {
          text: 'Select',
          value: null
        },
        {
          value: 'sole-proprietorship',
          text: 'Sole Proprietorship'
        },
        {
          value: 'single-member-llc',
          text: 'Single Member LLC'
        },
        {
          value: 'multi-member-llc',
          text: 'Multi Member LLC'
        },
        {
          value: 'private-partnership',
          text: 'Private Partnership'
        },
        {
          value: 'private-corporation',
          text: 'Private Corporation'
        },
        {
          value: 'other',
          text: 'Other/I\'m not sure'
        }
      ]
    }
  },
  created () {
    this.getOnboarding()
  },
  mounted () {
    setTimeout(() => {
      this.initPlaces()
    }, 500)
  },
  computed: {
    ...mapState('onBoarding', ['onboarding'])
  },
  methods: {
    ...mapActions('onBoarding', ['fetchOnboarding', 'saveOnboarding']),
    async getOnboarding () {
      const onBoardingForm = await this.fetchOnboarding()
      if (onBoardingForm.status) {
        this.onboardingForm = onBoardingForm.data
      }
    },
    async saveOnboardingForm () {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.$vs.loading()
          const saveStatus = await this.saveOnboarding({payload: this.onboardingForm})
          if (saveStatus.status) {
            this.openNotify({title: 'Success', icon: 'icon-check', text: saveStatus.message, color: 'success' })
            await this.$router.push({
              name: 'dashboard'
            })
          } else {
            this.openNotify({title: 'Error', icon: 'icon-alert-circle', text: saveStatus.message, color: 'danger' })
          }
          this.$vs.loading.close()
        } else {
          this.openNotify({title: 'Error', icon: 'icon-alert-circle', text: 'Validation Error', color: 'danger' })
        }
      })
    },

    initPlaces () {
      this.placeService = new window.google.maps.places.PlacesService(this.$refs.map)
    },

    getPlaceDetails (place_id, callback) {
      const self = this
      this.placeService.getDetails({placeId: place_id}, function (PlaceResult) {
        // PlaceResult is an object
        // PlacesServiceStatus is a string
        self.selectedPlace = PlaceResult
        callback(PlaceResult)
      })
    },
    placesFound (value) {
      this.business_address = value.description
      this.onboardingForm.street_address = value.terms[1].value
      this.onboardingForm.state = value.terms[3].value
      this.onboardingForm.city = value.terms[2].value

      this.getPlaceDetails(value.place_id, (PlaceResult) => {
        let adress_result = ''
        PlaceResult.address_components.filter(component => {
          if (component.types.includes('administrative_area_level_1')) {
            adress_result = component.short_name
            this.state = adress_result
          }
        })
        this.location = {
          lat: PlaceResult.geometry.location.lat(), lng: PlaceResult.geometry.location.lng()
        }
        this.onboardingForm.zip_code = PlaceResult.address_components.filter(comp => comp.types.includes('postal_code'))[0].long_name

      })
    },
    onValidate () {}
  }
}
</script>
